var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register"},[(_vm.current == 'Pc')?_c('TopNavigation'):_vm._e(),(_vm.current)?_c('Signup'+_vm.current,{tag:"component",attrs:{"downTimeEmail":_vm.downTimeEmail,"invite":_vm.invite},on:{"signup":_vm.signupClick,"signin":_vm.signinClick,"send":_vm.sendClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }